import React, { useState, useEffect } from 'react'
import { Input } from './../generic/UI/Input/Input';
import { Button } from './../generic/UI/Button/Button';

import { mailValidate, passValidate } from './../../form/formValidator';
import { auth } from './../../firebaseConfig';
import { useContext } from 'react';
import { Context } from '../../context';


const Reg = props => {

    const [mailType, setMailType] = useState()

    const [buttonType, setButtonType] = useState()

    const [passType, setPassType] = useState()

    const [email, setMail] = useState()

    const [password, setPassword] = useState()

    const [error, setError] = useState()

    const {setUser} = useContext(Context)


    useEffect(() => {
        if (passType === 'valid' && mailType === 'valid') {
            setButtonType('primary')
        } else {
            setButtonType('disabled')
        }

    }, [mailType, passType])

    const onChangeMail = event => {
        setMail(event.target.value)
        if (mailValidate(event.target.value)) {
            setMailType('valid')
        } else {
            setMailType('invalid')
        }
    }


    const onChangePass = event => {
        setPassword(event.target.value)
        if (passValidate(event.target.value)) {
            setPassType('valid')
        } else {
            setPassType('invalid')
        }

    }

    const handleSignUp = () => {
        auth.createUserWithEmailAndPassword(email, password)
            .then(response => setUser(response.user))
            .catch(err => setError(err.message))
    }

    return (
        <div className="form">
            <p className='form__title'>Регистрация</p>
            <p className='form__error'>{error}</p>
            <Input name='Email' value={email} onChange={onChangeMail} class={mailType} />
            <Input name='Пароль' value={password} type='password' class={passType} onChange={onChangePass} />
            <Button
                disabled={buttonType === 'primary' ? false : true}
                name='зарегистрироваться'
                class={buttonType}
                onClick={() => handleSignUp()}
            />
        </div>
    )
}


export default Reg